import React from 'react';

interface KBPageHeaderProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  actions?: React.ReactNode;
}

/**
 * Shared page header component for KB admin pages
 * Used in: KBUploadPage, KBDocumentsPage, KBEntityTypesPage, KBValidationPage
 */
const KBPageHeader: React.FC<KBPageHeaderProps> = ({
  icon,
  title,
  description,
  actions,
}) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div className="space-y-1">
        <div className="flex items-center gap-2">
          <span className="text-primary [&>svg]:h-7 [&>svg]:w-7">
            {icon}
          </span>
          <h1 className="text-2xl sm:text-3xl font-bold text-foreground tracking-tight">
            {title}
          </h1>
        </div>
        <p className="text-sm text-muted-foreground">
          {description}
        </p>
      </div>
      {actions && (
        <div className="flex items-center gap-2">
          {actions}
        </div>
      )}
    </div>
  );
};

export default KBPageHeader;
